import "./styles/main.scss";
import "styles/reset/reset.scss";
import "styles/g-grid-v2/g-grid.scss";
import Header from "Dashboard/components/Header";
import { Toolbox } from "./components/Toolbox";
import TableHeader from "./components/TableHeader";
import TableFooter from "./components/TableFooter";
import TableContent from "./components/TableContent";

const Incidents = () => {
  return (
    <>
      <Header title="Bonusi / kazne" />
      <Toolbox />
      <main id="incidents">
        <section className="loading-container">
          <TableHeader />
          <TableContent />
          <TableFooter />
        </section>
      </main>
    </>
  );
};

export default Incidents;
